import styled from "styled-components";

export const CardContainer = styled.div`
  border-radius: 8px;
  height: 100%;
  width: 100%;
`;
